export const Locations = (() => {
	'use strict';

	function init() {
		const $maps = document.querySelectorAll('[data-locations]')
		for (let i = 0; i < $maps.length; i++) {
			let $openRow = $maps[i].querySelector('[data-location-active="true"]')
			const $rows = $maps[i].querySelectorAll('[data-location-active]')
			for (let x = 0; x < $rows.length; x++) {
				const $row = $rows[x]
				const onClick = (ev) => {
					ev.stopPropagation()
					if ($row != $openRow) {
						$openRow && $openRow.setAttribute('data-location-active', false)
						$openRow = $row
						$openRow.setAttribute('data-location-active', true)
					}
				}
				$row.addEventListener('click', onClick)
			}
		}
	}

	return {
		init: init,
		name: 'locations'
	};
})();
